import React, { Fragment } from "react";
import { Field } from "redux-form";
import { renderField } from "../components";

const boxStying = { border: "1px solid #000", width: 20, height: 20 };

const Header = () => (
  <Fragment>
    <table style={{ width: "100%" }}>
      <tbody>
        <tr>
          <td>
            <img src="/assets/images/hdf/aviva-logo.png" alt="Aviva" style={{ width: "10vw" }} />
          </td>
          <td
            style={{
              textAlign: "center",
              fontWeight: "bold",
              fontSize: "16pt",
              verticalAlign: "middle",
              width: "80%",
            }}
          >
            HEALTH DECLARATION FORM
          </td>
          <td>
            <div style={{ border: "1px solid #000", padding: 10, width: 190 }}>
              For Official Use Only
              <br />
              Group Policy No:
              <br />
              <table style={{ borderCollapse: "collapse" }}>
                <tbody>
                  <tr>
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                    <td style={boxStying} />
                  </tr>
                </tbody>
              </table>
              <br />
              <table>
                <tbody>
                  <tr>
                    <td>Date:</td>
                    <td
                      style={{
                        width: "80%",
                        borderBottom: "1px solid #000",
                      }}
                    />
                  </tr>
                </tbody>
              </table>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
    &nbsp;
    <br />
    <div
      style={{
        color: "#f00",
        fontWeight: "bold",
        fontSize: "12pt",
        padding: 10,
        border: "1px solid #000",
      }}
    >
      IMPORTANT NOTE: Pursuant to Section 25(5) of the Insurance Act (Cap. 142), you are to disclose
      in this form, fully and faithfully, all the facts <br />
      which you know or ought to know, otherwise, nothing may be payable under the Policy.
    </div>
    <br />
    <div style={{ display: "flex", margin: "0.5em 0" }}>
      <div>Name of Company: </div>
      <div
        style={{ flexGrow: 1, marginLeft: "1em", borderBottom: "1px solid black" }}
        id="RO_CompanyName"
      >
        <Field component={renderField} type="hidden" id="CompanyName" name="CompanyName" />
      </div>
    </div>
    <div style={{ display: "flex", margin: "0.5em 0" }}>
      <div>Plan Type: </div>
      <div style={{ flexGrow: 1, marginLeft: "1em", borderBottom: "1px solid black" }} />
    </div>
    &nbsp;
    <br />
  </Fragment>
);

export default Header;



// WEBPACK FOOTER //
// ./components/employee/hdf-forms/Aviva/AVIVAHD201910/Header.js